import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Star, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-yellow-300 flex items-center justify-center px-6 font-body">
      <form
        data-testid="admin-login-form"
        onSubmit={onSubmit}
        className="bg-white rounded-[2rem] p-8 sm:p-10 w-full max-w-md shadow-pop"
      >
        <div className="flex flex-col items-center mb-6">
          <img src={LOGO_URL} alt="WonderStarzLV logo" className="h-20 w-20 object-contain" />
          <h1 className="font-display font-bold text-2xl text-pink-500 mt-3 flex items-center gap-2">
            <Lock className="w-5 h-5" /> Admin Login
          </h1>
          <p className="text-emerald-700 font-medium text-sm">WonderStarzLV control panel</p>
        </div>

        {error && (
          <div data-testid="admin-login-error" className="bg-red-50 text-red-600 rounded-xl px-4 py-2 text-sm font-medium mb-4">
            {error}
          </div>
        )}

        <label className="block font-display font-semibold text-emerald-800 mb-1.5 text-sm">Email</label>
        <input
          data-testid="admin-email-input"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full rounded-xl border-2 border-teal-200 focus:border-pink-400 px-4 py-3 mb-4 focus:outline-none focus:ring-2 focus:ring-pink-300"
          placeholder="admin@wonderstarzlv.com"
        />
        <label className="block font-display font-semibold text-emerald-800 mb-1.5 text-sm">Password</label>
        <input
          data-testid="admin-password-input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full rounded-xl border-2 border-teal-200 focus:border-pink-400 px-4 py-3 mb-6 focus:outline-none focus:ring-2 focus:ring-pink-300"
          placeholder="••••••••"
        />
        <button
          data-testid="admin-login-btn"
          type="submit"
          disabled={loading}
          className="w-full bg-pink-500 text-white font-display font-bold text-lg py-3.5 rounded-full hover:bg-pink-600 transition disabled:opacity-60 flex items-center justify-center gap-2"
        >
          <Star className="w-5 h-5" fill="white" /> {loading ? "Signing in..." : "Sign In"}
        </button>
      </form>
    </div>
  );
}
